import { AccordionList, Button, Typography } from '@sonnen/web-ui';
import { parseHtmlTags } from '@sonnen/web-utils';
import { useMemo } from 'react';
import { useAppContext } from '../../../AppContext/AppContext';
import { LocaleKey, useTranslation } from '../../../i18n/i18n';
import { OrderFlow } from '../../../types';
import styles from './FAQList.module.css';

const FAQList = () => {
  const { t } = useTranslation();
  const { orderFlow } = useAppContext();

  const listData = useMemo(() => {
    const keys = {
      energyDynamic: [
        'smartMeter',
        'priceOptimization',
        'providerChange',
        'electricitySupplyStart',
      ],
      energyFix: [
        'contractCancellation',
        'providerChange',
        'electricitySupplyStart',
        'noticePeriod',
      ],
    };
    const selectedFlow = orderFlow === OrderFlow.energyFix ? 'energyFix' : 'energyDynamic';

    return keys[selectedFlow].map((key) => ({
      dataTestId: key,
      label: t(`confirmation.accordion.${selectedFlow}.${key}.label` as LocaleKey),
      children: (
        <Typography.Body1 variant="on-colour">
          {parseHtmlTags(
            t(`confirmation.accordion.${selectedFlow}.${key}.description` as LocaleKey),
          )}
        </Typography.Body1>
      ),
    }));
  }, [t]);

  return (
    <div className={styles.faqList} data-testid="order-complete-FAQ-list">
      <Typography.H2 variant="on-colour">{t('confirmation.accordion.faqTitle')}</Typography.H2>

      <div className={styles.list}>
        <AccordionList list={listData} dataTestId="FAQ-list" variant="dark" />
      </div>

      <div className={styles.contact}>
        <Typography.Label1 variant="on-colour">
          {t('confirmation.anotherQuestionBtn')}
        </Typography.Label1>

        <div className={styles.buttons}>
          <Button
            iconRight="ExternalLink"
            variant="secondary"
            size="small"
            label={t('confirmation.searchFaqBtn')}
            dataTestId="button-search-FAQ"
            onClick={() => window.open('https://sonnen.de/haeufig-gestellte-fragen/', '_blank')}
            expanded
          />
          <Button
            iconRight="ArrowRight"
            size="small"
            label={t('confirmation.customerService')}
            dataTestId="button-customer-service"
            onClick={() => window.open('https://sonnen.de/kontakt/', '_blank')}
          />
        </div>
      </div>
    </div>
  );
};
export default FAQList;
